import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import BigHierarchyMultipicklistControl from 'Components/ComponentLibrary/Components/Inputs/Multipicklist/BigHierarchyMultipicklistControl';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import {
  FDStack, FDBox,
} from '@facet-wealth/design';
import AssetsAndLiabilitiesHeader
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/AssetsAndLiabilitiesPartnerQuestion/AssetsAndLiabilitiesHeader';

function OnboardingAssetsAndLiabilitiesOverallChecklist() {
  const {
    resource,
    handleChange,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();
  useScrollTopOnMount();

  return (
    <FDBox>
      <FDStack direction={'column'} spacing={4}>
        <AssetsAndLiabilitiesHeader resource={resource} />
        <BigHierarchyMultipicklistControl
          options={resource.meta().field('options').options().list()}
          value={resource?.attr('options') || []}
          onChange={(value) => {
            return handleChange('options', value);
          }}
          testName={'assets-and-liabilities'}
          isLegacy={false}
          hasSearch={false}
        />
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
        nextButtonLabel={'Continue'}
        NextButtonProps={{
          disabled: resource.attr('options').length === 0,
        }}
      />
    </FDBox>
  );
}

OnboardingAssetsAndLiabilitiesOverallChecklist.propTypes = {
};

OnboardingAssetsAndLiabilitiesOverallChecklist.defaultProps = {
};


export default OnboardingAssetsAndLiabilitiesOverallChecklist;
